<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-width="100px" label-position="left">
        <el-form-item label="最近登陆时间">
          <date-range-picker :value="loginTime" @getChange="value => loginTime = value"></date-range-picker>
        </el-form-item>
        <el-form-item label="代理商编号">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"></el-input>
        </el-form-item>
        <!-- <el-form-item label="代理商编号" v-if="$store.state.userInfo.userType !== 3">
          <el-input v-model="searchForm.agentId" placeholder="请输入代理商编号" :clearable="true"></el-input>
        </el-form-item> -->
        <el-form-item label="关联银行">
          <el-select v-model="searchForm.code" placeholder="请选择银行" :clearable="true" filterable>
            <el-option v-for="item in bankList" :label="item.name" :value="item.code" :key="item.code"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="登录名">
          <el-input v-model="searchForm.userName" placeholder="请输入登录名" clearable></el-input>
        </el-form-item>
        <el-form-item label="启用状态">
          <el-select v-model="searchForm.status" placeholder="请选择用户状态" :clearable="true">
            <el-option
              v-for="item in statusList"
              :key="item.status"
              :label="item.text"
              :value="item.status">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.userType" placeholder="请选择角色" :clearable="true">
            <el-option v-for="item in roleList" :key="item.type" :label="item.text" :value="item.type"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
      </el-form>
    </module-card>
    <module-card title="用户管理">
      <el-button type="primary" icon="el-icon-plus" v-if="[0,1,9].includes($store.state.userInfo.userType)" @click="toAddUser">新增</el-button>
      <el-table class="table" border :data="list" v-loading="searchLoading">
        <el-table-column
          label="创建时间"
          width="100"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="最近登陆"
          width="100"
          prop="lastLoginTime">
        </el-table-column>
        <el-table-column
          label="登录名"
          prop="loginName">
        </el-table-column>
        <el-table-column
          label="编号"
          width="110"
          prop="unionCode">
        </el-table-column>
        <el-table-column
          label="角色"
          prop="role">
          <template slot-scope="scope">
            <span>{{getText(scope.row.role, 'roleList')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="姓名/名称"
          prop="realName">
        </el-table-column>
        <el-table-column
          label="状态"
          width="70"
          prop="status">
          <template slot-scope="scope">
            <span>{{getText(scope.row.status, 'statusList')}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="来源"
          prop="source">
          <template slot-scope="scope">
            <span>{{scope.row.source === 0 ? '系统添加' : '小程序'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建人"
          prop="creator">
        </el-table-column>
        <el-table-column
          label="归属一级代理商"
          prop="agentId1g">
        </el-table-column>
        <el-table-column
          label="关联账号"
          prop="agentId2g">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="195">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="user_detail" @click.native="checkDetails(scope.row)" label="详情"></auth-button>
            <auth-button auth-type="span" opt="user_edit" @click.native="isCheckDetail = false;editUser(scope.row)" label="编辑"></auth-button>
            <auth-button auth-type="span" opt="user_reset_psd" @click.native="toResetPsd(scope.row)" label="重置密码"></auth-button>
            <auth-button auth-type="span" opt="change_agent" @click.native="openChangeAgent(scope.row)" label="更换一代" v-if="scope.row.role === 5"></auth-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="searchForm.pageNo" :size="searchForm.pageSize" @changePage="value => { searchForm.pageNo = value;getList() }"></pagination>
    </module-card>
    <dialog-info :visible.sync="showUserDialog" :title="isCheckDetail? '详情' : (userForm.unionCode ? '编辑用户' : '新增用户')"
      @confirm="submitUser"
      :confirmLoading="userEditLoading"
      :cancel-text="isCheckDetail? '关闭' : '取消'"
      :show-confirm-btn="!isCheckDetail">
      <el-form ref="userForm" :model="userForm" :rules="ruleData" label-width="100px" label-position="left" :disabled="isCheckDetail">
        <el-form-item prop="loginName" label="登录名">
          <el-input v-model="userForm.loginName" placeholder="6~20位 数字/字母" :disabled="userForm.unionCode !== ''" autoComplete="off"></el-input>
        </el-form-item>
        <el-form-item prop="passWord" label="登录密码" v-if="!userForm.unionCode">
          <el-input v-model="userForm.passWord" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合" autoComplete="new-password"></el-input>
        </el-form-item>
        <el-form-item prop="unionCode" label="编号" v-if="userForm.unionCode">
          <el-input v-model="userForm.unionCode" :disabled="userForm.unionCode !== ''"></el-input>
        </el-form-item>
        <el-form-item prop="mobile" label="手机号">
          <el-input v-model="userForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item prop="email" label="邮箱">
          <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item prop="status" label="状态">
          <el-radio-group v-model="userForm.status">
            <el-radio v-for="item in statusList" :key="item.status" :label="item.status">{{item.text}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="role" label="角色">
          <el-radio-group v-model="userForm.role" class="roleRadio">
            <!-- 支持超级管理员变更运营账号角色 普通运营和联合收单运营 -->
            <el-radio v-for="item in dialogRoleList" :disabled="roleRadioDisabled(item,userForm)"  :key="item.type" :label="item.type">{{item.text}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="realName" label="姓名/名称" v-if="[0, 1, 6, 7].includes(userForm.role)" :required="[7].includes(userForm.role)">
          <el-input v-model="userForm.realName" placeholder="请输入20字以内姓名/名称"></el-input>
        </el-form-item>
        <el-form-item prop="bindCode" label="归属机构" v-if="[4, 7].includes(userForm.role)" :required="[7].includes(userForm.role)">
          <el-select v-model="userForm.bindCode" placeholder="请选择归属银行" @change="handleBankSelect" :disabled="[7].includes(userForm.role) && userForm.unionCode !== ''" filterable>
            <el-option v-for="(item, index) in bankList" :key="index" :value="item.code" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <!-- 代理商辅账号6和推广员5有该参数 todo: 2-->
        <el-form-item prop="agentId1g" label="一级代理商" v-show="[5, 6].includes(userForm.role)">
          <el-input v-model="userForm.agentId1g" @blur="searchAgent" placeholder="请输入id查询代理商" :disabled="userForm.unionCode !== ''"></el-input>
          <p>{{agent1dName}}</p>
        </el-form-item>
        <!-- 代理商辅账号必填关联代理商 todo: 2-->
        <el-form-item prop="agentId2g" label="关联代理商" v-show="[6].includes(userForm.role)">
          <el-input v-model.trim ="userForm.agentId2g" placeholder="请输入关联代理商"></el-input>
        </el-form-item>
        <!-- 推广员必填关联编号 -->
        <el-form-item prop="operator" label="关联编号" v-if="[5].includes(userForm.role)">
          <el-input v-model.trim="userForm.operator" placeholder="请输入关联编号"></el-input>
          <p>可关联聚合业务员、代理商编号以获得对应数据权限;若关联编号为空，则不可查询任何商户资料</p>
        </el-form-item>
        <!-- 聚合商户业务员 -->
        <!-- <el-form-item prop="actor" label="业务员" v-if="userForm.role === 3">
          <el-input v-model.trim="userForm.operator" placeholder="请输入业务员编号"></el-input>
        </el-form-item> -->
        <!-- 银行、推广员选填地区 -->
        <el-form-item label="地址" v-show="[4, 5, 7].includes(userForm.role)">
          <address-select ref="addressForm" v-model="userForm.address" :require="false" :show-area="false" :readOnly="isCheckDetail" @getValue="getAddress"></address-select>
        </el-form-item>
        <el-form-item prop="provinceNoList" label="BD展业区域" v-if="[10].includes(userForm.role)" :class="['1'].includes(userForm.isCountry) ? 'is-required' : ''">
          <el-radio-group v-model="userForm.isCountry">
            <el-radio label="0">全国</el-radio>
            <el-radio label="1">指定省市</el-radio>
          </el-radio-group>
          <el-select v-model="userForm.provinceNoList" multiple clearable placeholder="请选择BD展业区域" style="width: 100%" :disabled="userForm.isCountry === '0'">
            <el-option
              v-for="item in addressList"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item prop="realName" label="乐刷销售BD邮箱" label-width="120px">
          <el-input v-model="userForm.realName" placeholder="请输入BD的企业邮箱地址" style="width: 65%"></el-input> @yeahka.com
        </el-form-item> -->
      </el-form>
    </dialog-info>
    <!-- <dialog-info title="重置密码" :visible.sync="showResetPsd" :confirmLoading="resetPsdLoading" @confirm="resetPsd"> -->
    <dialog-info title="重置密码" :visible.sync="showResetPsd" :confirmLoading="resetPsdLoading" :showCancelBtn="false" :showConfirmBtn="false">
      <el-form ref="passwordForm" :model="passwordForm" label-position="left" :rules="resetRule" label-width="80px">
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="passwordForm.mobile" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="验证码" prop="mobileVerifyCode">
          <el-input v-model="passwordForm.mobileVerifyCode" placeholder="请输入验证码" style="width: 220px"></el-input>
          <el-button style="width: 110px; padding: 12px 20px; margin-left: 10px" type="primary" :disabled="disabledSend" @click="sendCode('passwordForm')">{{ btntext }}</el-button>
        </el-form-item>
        <div v-if="verifyPass" style="float: left; margin: 10px 0 0 50%; transform: translate(-50%)">
          <el-button type="primary" @click="checkCode">下一步</el-button>
        </div>
        <div v-else>
          <el-form-item label="新密码" prop="newPassWord">
            <el-input v-model="passwordForm.newPassWord" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合" autoComplete="new-password"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input v-model="passwordForm.confirmPassword" type="password" placeholder="8-20位大写/小写字母/数字/符号至少三种组合" autoComplete="new-password"></el-input>
          </el-form-item>
          <div style="float: right">
            <el-button @click="showResetPsd = false">取消</el-button>
            <el-button type="primary" @click="resetPsd">确认</el-button>
          </div>
        </div>
      </el-form>
    </dialog-info>
    <!-- 更换一代弹窗 -->
    <dialog-info title="更换一代" :visible.sync="showChangeAgent" :confirmLoading="changeAgentLoading" @confirm="changeAgentBtn" @close="clsAgentForm" footerAlign="center">
      <el-form ref="bindCode" :model="changeAgentForm" label-width="80px">
          <el-input v-model="changeAgentForm.bindCode" placeholder="请输入新的所属一级代理商编号" clearable></el-input>
      </el-form>
    </dialog-info>
  </div>
</template>

<script>
import dialogInfo from '@/components/layout/dialogInfo'
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import addressSelect from '@/components/addressSelect'
import { validStrictPsd, strictPsdError } from '@/assets/js/utils'

const md5 = require('md5')
export default {
  name: 'userManage',
  components: {
    dateRangePicker: dateRangePicker,
    pagination: pagination,
    dialogInfo: dialogInfo,
    addressSelect
  },
  data () {
    return {
      loginTime: [],
      searchForm: {
        userName: '',
        loginTimeStart: '',
        loginTimeEnd: '',
        agentId: '',
        code: '',
        name: '',
        role: '',
        mobile: '',
        status: '',
        pageSize: 10,
        pageNo: 1
      },
      list: [],
      searchLoading: false,
      listLoading: false,
      total: 1,
      showUserDialog: false,
      userEditLoading: false,
      isCheckDetail: false,
      userForm: {
        unionCode: '', // 用户编号
        loginName: '',
        mobile: '',
        passWord: '',
        realName: '',
        status: 0,
        role: '',
        bindCode: '',
        agentId1g: '',
        agentId2g: '',
        operator: '',
        address: {
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: ''
        },
        email: '',
        bindBankName: '',
        isCountry: '0',
        provinceNoList: []
      },
      ruleData: {
        loginName: [{
          validator: (rule, value, callback) => {
            if (/^[a-zA-Z0-9]{6,20}$/.test(value)) {
              callback()
            } else {
              callback(new Error('请输入6~20位数字/字母组合登录名'))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        passWord: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        realName: [{
          validator: (rule, value, callback) => {
            if (value !== '' && !(/^.{1,20}$/.test(value))) {
              callback(new Error('请输入20字以内姓名/名称'))
            } else if ([7].includes(this.userForm.role) && !(/^.{1,20}$/.test(value))) {
              callback(new Error('请输入20字以内姓名/名称'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        newPassWord: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        mobile: [{
          validator: (rule, value, callback) => {
            // !/^\d{3}\*{4}\d{4}$/.test(value)
            if (value !== '' && !/\*|^\d{11,11}$/.test(value)) {
              callback(new Error('请输入正确格式的手机号'))
            } else {
              callback()
            }
          }
        }],
        bindCode: [{
          validator: (rule, value, callback) => {
            if (value === '' && [4, 7].includes(this.userForm.role)) {
              callback(new Error('请选择归属银行'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
          require: true
        }],
        agentId1g: [{
          validator: (rule, value, callback) => {
            if (value === '' && [5, 6].includes(this.userForm.role)) {
              callback(new Error('请输入一级代理商'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
          required: true
        }],
        agentId2g: [{
          validator: (rule, value, callback) => {
            if (value === '' && [6].includes(this.userForm.role)) {
              callback(new Error('请输入关联代理商'))
            } else {
              callback()
            }
          },
          trigger: 'blur',
          required: true
        }],
        operator: [{
          pattern: /^[1-9]{1}\d/,
          trigger: 'blur',
          message: '请输入正确关联编号'
        }],
        provinceNoList: [{
          validator: (rule, value, callback) => {
            if (this.userForm.isCountry === '1' && value.length === 0) {
              callback(new Error('请选择销售BD展业区域'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        }],
        email: [{
          required: false,
          trigger: 'blur',
          pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/,
          message: '邮箱格式有误'
        }]
      },
      // 重置密码
      resetRule: {
        mobile: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入手机号'))
            } else {
              if (/\*|^\d{11,11}$/.test(value)) {
                return callback()
              }
              callback(new Error('请输入正确格式的手机号'))
            }
          }
        }],
        confirmPassword: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error(strictPsdError))
            } else if (value !== this.passwordForm.newPassWord) {
              callback(new Error('两次密码不一致!'))
            } else if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }],
        mobileVerifyCode: [{
          validator: (rule, value, callback) => {
            if (value === '') {
              callback(new Error('请输入验证码'))
            } else {
              callback()
            }
          },
          trigger: 'blur'
        }],
        newPassWord: [{
          validator: (rule, value, callback) => {
            if (validStrictPsd(value)) {
              callback()
            } else {
              callback(new Error(strictPsdError))
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      roleList: [], // 角色列表
      addRoleList: [
        { type: 0, text: '超级管理员' },
        { type: 1, text: '普通运营' },
        { type: 4, text: '银行人员' },
        { type: 7, text: '银行子行号' },
        { type: 9, text: '联合收单运营' },
        { type: 10, text: '销售BD' }
      ],
      statusList: [], // 用户状态列表
      showResetPsd: false,
      resetPsdLoading: false,
      passwordForm: {
        userName: '',
        newPassWord: '',
        confirmPassword: '',
        mobileVerifyCode: '',
        mobile: ''
      },
      bankList: [],
      agent1dName: '',
      showChangeAgent: false,
      changeAgentForm: {
        bindCode: '',
        unionCode: '',
        realName: ''
      },
      disabledSend: false,
      time: 60,
      btntext: '发送验证码',
      verifyPass: true, // 重置密码的显示与隐藏
      addressList: [],
      changeAgentLoading: false,
      editType: 'add'
    }
  },
  computed: {
    dialogRoleList () {
      let list = []
      if (!this.isCheckDetail) {
        list = this.addRoleList
      } else {
        list = this.roleList
      }
      return list
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    roleRadioDisabled (item, scope) {
      if (this.editType === 'checkDetail') { // 查看详情
        return true
      } else if (this.editType === 'add') { // 新增
        if (this.$store.state.userInfo.userType === 0) { // 超管
          return false
        } else if (this.$store.state.userInfo.userType === 1) { // 登录用户为普通运营角色的，支持新增除超管、联合收单运营、普通运营以外的角色
          if (item.type === 0 || item.type === 1 || item.type === 9) {
            return true
          } else {
            return false
          }
        } else if (this.$store.state.userInfo.userType === 9) { // 登录用户为联合收单运营的，支持新增除超管、联合收单运营以外的角色
          if (item.type === 0 || item.type === 9) {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      } else { // 编辑
        if (this.$store.state.userInfo.userType === 0 && (item.type === 1 || item.type === 9) && (scope.role === 1 || scope.role === 9)) { // 当为普通运营或联合收单运营角色时，支持超级管理员变更运营账号角色
          return false
        } else {
          return true
        }
      }
    },
    async init () {
      this.searchLoading = true
      await this.getBankList()
      if (await this.getRoleList()) {
        this.getList()
      } else {
        // this.$message({
        //   type: 'error',
        //   message: '服务器走丢了...'
        // })
        this.searchLoading = false
      }
      this.getAddressList()
    },
    getAddressList () {
      this.$axios.post(this.$api.addressList, {}).then(res => {
        if (res.respCode === '0') {
          this.addressList = res.data.list
        }
      })
    },
    search () {
      this.getList()
    },
    getList () {
      this.searchLoading = true
      this.searchForm.loginTimeStart = this.loginTime[0] || ''
      this.searchForm.loginTimeEnd = this.loginTime[1] || ''
      this.$axios.post(this.$api.userList, this.searchForm).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
      })
    },
    getRoleList () {
      const that = this
      return new Promise(resolve => {
        this.$axios.get(this.$api.roleStateList).then(res => {
          if (res.respCode === '0') {
            that.roleList = res.typeList
            that.statusList = res.statusList
            that.userForm.role = this.$store.state.userInfo.userType
            resolve(true)
          } else {
            resolve(false)
          }
        }).catch(e => {
          resolve(false)
        })
      })
    },
    submitUser () {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          if (this.userEditLoading) {
            return
          }
          this.userEditLoading = true
          let api
          let message
          let params
          if (this.userForm.unionCode) {
            api = 'editUser'
            if (this.userForm.role === 6) {
              api = 'editAgentAssist'
            }
            params = this.userForm
            message = '编辑成功！'
          } else {
            api = 'addUser'
            if (this.userForm.role === 6) {
              api = 'addAgentAssist'
            }
            params = Object.assign({}, this.userForm, {
              passWord: md5(this.userForm.passWord)
            })
            message = '新增成功！'
          }
          this.$axios.post(this.$api[api], params).then(res => {
            this.userEditLoading = false
            if (res.respCode === '0') {
              this.showUserDialog = false
              this.$message({
                type: 'success',
                message: message
              })
              this.search()
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    editUser (row) {
      this.editType = 'edit'
      this.userForm = this.$options.data().userForm
      this.agent1dName = ''
      // 只引用值而不是指针，否则会导致row.address跟着修改
      this.userForm = JSON.parse(JSON.stringify(row))
      this.showUserDialog = true
      this.userForm.address = (row.address && typeof row.address === 'string') ? JSON.parse(row.address) : this.$options.data().userForm.address
      if (this.userForm.role === 5) {
        this.userForm.agentId1g = this.userForm.bindCode
      }
      const that = this
      setTimeout(() => {
        that.$refs.userForm.clearValidate()
        that.$refs.addressForm.$refs.form.clearValidate()
      }, 100)
    },
    toResetPsd (row) {
      this.passwordForm = this.$options.data().passwordForm
      this.passwordForm.userName = row.loginName
      this.showResetPsd = true
      setTimeout(() => {
        this.$refs.passwordForm.clearValidate()
        // this.$refs.addressForm.$refs.form.clearValidate()
      }, 100)
    },
    // 打开更换一代弹窗
    openChangeAgent (row) {
      this.showChangeAgent = true
      this.changeAgentForm.unionCode = row.unionCode
      this.changeAgentForm.realName = row.realName
    },
    // 更换一代
    changeAgentBtn () {
      this.changeAgentLoading = true
      this.$axios.post(this.$api.changeAgent, this.changeAgentForm).then(res => {
        if (res.respCode === '0') {
          this.changeAgentLoading = false
          this.showChangeAgent = false
          this.$message({
            type: 'success',
            message: res.respMsg
          })
          this.init()
        } else {
          this.changeAgentLoading = false
        }
      })
    },
    clsAgentForm () {
      this.showChangeAgent = false
      this.changeAgentForm = this.$options.data().changeAgentForm
    },
    resetPsd () {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          if (this.resetPsdLoading) {
            return
          }
          this.resetPsdLoading = true
          const params = {
            userName: this.passwordForm.userName,
            mobile: this.passwordForm.mobile,
            newPassWord: md5(this.passwordForm.newPassWord),
            passSession: this.passwordForm.passSession
          }
          this.$axios.post(this.$api.resetPsd, params).then(res => {
            this.resetPsdLoading = false
            if (res.respCode === '0') {
              this.$message({
                type: 'success',
                message: '重置密码成功！'
              })
              this.showResetPsd = false
              this.verifyPass = true
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    getText (id, type) {
      const list = this[type].filter(item => {
        return (item.type === id) || (item.status === id)
      })
      if (list.length === 0) {
        return ''
      } else {
        return list[0].text
      }
    },
    toAddUser () {
      this.editType = 'add'
      this.showUserDialog = true
      this.isCheckDetail = false
      this.userForm = this.$options.data().userForm
      this.agent1dName = ''
      this.userForm.role = this.$store.state.userInfo.userType
      const that = this
      setTimeout(function () {
        that.$refs.userForm.clearValidate()
        that.$refs.addressForm.$refs.form.clearValidate()
      }, 100)
    },
    checkDetails (row) {
      this.editType = 'checkDetail'
      this.isCheckDetail = true
      this.editUser(row)
    },
    getBankList () {
      return new Promise((resolve, reject) => {
        this.$axios.post(this.$api.bankList, {}).then(res => {
          if (res.respCode === '0') {
            this.bankList = res.data.list
          }
          resolve()
        }).catch(e => {
          reject(e)
        })
      })
    },
    getAddress (val) {
      this.userForm.address = val
    },
    searchAgent () {
      this.$axios.post(this.$api.searchAgent, {
        agentId: this.userForm.agentId1g
      }).then(res => {
        if (res.respCode === '0') {
          this.agent1dName = res.data.title
        } else {
          this.agent1dName = '找不到对应代理商'
        }
      })
    },
    handleBankSelect (value) {
      const bindBank = this.bankList.filter(item => item.code === value)
      this.userForm.bindBankName = bindBank[0] ? bindBank[0].name : ''
    },
    sendCode (passwordForm) {
      this.$refs[passwordForm].validateField('mobile', valid => {
        if (!valid) {
          const params = {
            userName: this.passwordForm.userName,
            mobile: this.passwordForm.mobile
          }
          this.$axios.post(this.$api.sendVailCode, params).then(res => {
            if (res.respCode === '0') {
              this.$message({
                message: '发送成功',
                type: 'success'
              })
              this.time = 60
              this.timer()
            }
          })
        }
      })
    },
    timer () {
      if (this.time > 0) {
        this.disabledSend = true
        this.time--
        this.btntext = this.time + '秒'
        setTimeout(this.timer, 1000)
      } else {
        this.time = 0
        this.btntext = '发送验证码'
        this.disabledSend = false
      }
    },
    checkCode () {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          const params = {
            userName: this.passwordForm.userName,
            mobile: this.passwordForm.mobile,
            mobileVerifyCode: this.passwordForm.mobileVerifyCode
          }
          this.$axios.post(this.$api.checkVailCode, params).then(res => {
            if (res.respCode === '0') {
              this.passwordForm.passSession = res.data.passSession
              this.verifyPass = false
            }
          })
        }
      })
    }
  },
  watch: {
    'userForm.isCountry': {
      handler (val) {
        if (val === '0') {
          this.userForm.provinceNoList = this.$options.data().userForm.provinceNoList
        }
      }
    },
    'userForm.role': {
      handler (val) {
        if (val !== 10) {
          this.userForm.isCountry = '0'
          this.userForm.provinceNoList = this.$options.data().userForm.provinceNoList
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.table{
  margin-top: 20px;
}
.roleRadio{
  .el-radio{
    margin-bottom: 15px;
  }
}
.verifyInput{
  width: 130px;
  margin-right: 9px;
  margin-bottom: 0;
}
.validImg{
  width: 100px;
  height: 46px;
  margin-right: 8px;
  cursor: pointer;
}
.changeCode{
  color: var(--main-color);
  cursor: pointer;
}
</style>
